module.exports = __webpack_public_path__ + "static/img/预算管控_迷你版.cbecf44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/预算管控_迷你版.jpg
// module id = DRG/
// module chunks = 1